import styled from "styled-components";

export const FilterBarContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 90px;
`;

export const FilterBarLeftContent = styled.div`
  display: flex;
  gap: 16px;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  align-items: flex-start;
`;

export const FilterBarRightContent = styled.div`
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  align-items: center;
  width: 150px;
  height: 100%;
  padding-inline-start: 30px;
`;